import * as React from 'react';

/**
 * True when library surfaces (program cards, the upgrade banner, the program
 * detail button) should name VIP instead of Premium. Cards say VIP for every
 * viewer, Premium members included (Alex approved Oct 29 2026).
 *
 * VipPlanNameProvider reads the flag once, so leaf cards need no query
 * client. Outside the provider (tests) the value is false: Premium.
 */
export const VipPlanNameContext = React.createContext(false);

/**
 * True while the flag answer is not known yet. A surface that names the plan
 * holds a neutral state (no plan name) until it is false.
 */
export const VipPlanNamePendingContext = React.createContext(false);

export function useVipPlanName(): boolean {
  return React.useContext(VipPlanNameContext);
}

export function useVipPlanNameState(): { vip: boolean; pending: boolean } {
  return { vip: React.useContext(VipPlanNameContext), pending: React.useContext(VipPlanNamePendingContext) };
}
